import type { Options } from 'slug';
import slug from 'slug';

const DEFAULT_OPTIONS = {
  replacement: '_', // use underscore as separator
  symbols: true,
  remove: /[^\w\s-]/g, // allow underscores
  lower: true,
} as const;

/**
 * Generate a slug while preserving underscores (including consecutive ones)
 */
export function slugKeepUnderscore(value: string, options?: Partial<Options>, preserveChar = '_'): string {
  const placeholderMap = new Map<string, string>();
  let counter = 0;
  const mergedOptions = { ...DEFAULT_OPTIONS, ...options };

  const replacedValue = value.replace(/\s/g, mergedOptions.replacement || preserveChar).replace(/_+/g, (match) => {
    const key = `ph${counter}x`;

    placeholderMap.set(key, match);
    counter++;

    return key;
  });

  let replacedSlug = slug(replacedValue, mergedOptions);

  // Restore the underscores from the placeholders
  placeholderMap.forEach((original, placeholder) => {
    replacedSlug = replacedSlug.replace(new RegExp(placeholder, 'g'), original);
  });

  return replacedSlug;
}
